let ytplaceholder = document.getElementById('ytplaceholder');

if (ytplaceholder) {
  var videolistner = function () {
    var ytiframe = <HTMLImageElement>document.getElementById('ytiframe');
    if (ytiframe) {
      ytiframe.src = ytiframe.getAttribute('data-src') ?? "";
      ytiframe.onload = () => ytiframe.style.opacity = '1';
      if (ytplaceholder) {
        ytplaceholder.removeEventListener("mouseover", videolistner);
      }
    }
  };

  ytplaceholder.addEventListener('mouseover', videolistner);

  // show the YouTube video anyway after 3 seconds
  setTimeout(function () {
    videolistner();
  }, 3000);
}
